<template>
    <div>
      <ul class="story-list">
        <li v-for="(item, index) in list" :key="index">
          <p class="story-title">{{ item.title }}</p>
        </li>
      </ul>
    </div>
  </template>
  <script>
  export default {
    data(){
      return{
          list: [
           
          ]
      }
    }
  }
  </script>
  <style lang="scss" scoped>
    .story-list {
      display: flex;
      justify-content: space-around;
      align-items: center;
      li {
        width: 25%;
        .story-title {
  
        }
      }
    }
  </style>